(function (appComponents) {

	appComponents.controllers.orderDetails = function (Components) {
		var orderDetails = {};

		orderDetails.name = "orderDetails";

		Components.getControllerPrototype().extend(orderDetails);

		orderDetails._cart = orderDetails._getService("cartBase");
		orderDetails._product = orderDetails._getService("productBase");
		orderDetails._modals = orderDetails._getService("modals");
		orderDetails._b2bUnit = orderDetails._getService("b2bUnit");
		orderDetails._orders = orderDetails._getService("ordersBase");

		orderDetails.itemCollection = orderDetails._getPageComponent("orderItemCollection");
		
		

		orderDetails.elements = {
			get productTable() {
				return $('[pc-container="order-details--product-table"]');
			}
		};

		orderDetails.bindings = function () {
			orderDetails._elements.page.on("click", '[pc-container="order-details--item-title"]', function () {
				var entryNumber = $(this).closest('[pc-container="order-details--item"]').attr("pc-value");
				orderDetails.handlers.onProductTitleClick(entryNumber);
			});
			orderDetails._elements.page.on("click", '[pc-container="order-details--item-add-to-cart"]', function () {
				var entryNumber = $(this).closest('[pc-container="order-details--item"]').attr("pc-value");
				orderDetails.handlers.onAddToCartItem(entryNumber);
			});
			orderDetails._elements.page.on("click", '[pc-container="order-details--item-datapack"]', function () {
				var entryNumber = $(this).parent().closest('[pc-container="order-details--item"]').attr("pc-value");
				var type = $(this).attr("pc-value");
				orderDetails.handlers.onDataPackItemClick(entryNumber, type);
			});
			orderDetails._elements.page.on("click", '[pc-container="order--dl-pdf"]', function () {
				var code = orderDetails.context.order.code;
				orderDetails._orders.handlers.onDownloadPdf(code);
			});
			orderDetails._elements.page.on("click", '[pc-container="order-details--go-back-btn"]', function () {
				orderDetails.handlers.onGoBack();
			});

		};

		orderDetails.liveBindings = function () {
			$('.ship-det').off().on("click", function () {
				$(this).closest('.order-search-table-body').find('.ship-det-table').toggleClass('dis-none');
				$(this).find(".fa").toggleClass('fa-plus fa-minus');
			});
			$('.ship-det1').off().on("click", function () {
				$(this).closest('.order-search-table-body1').find('.ship-det-table1').toggleClass('dis-none');
				$(this).find(".fa").toggleClass('fa-plus fa-minus');
			});
			$('.ship-det2').off().on("click", function () {
				$(this).closest('.order-search-table-body2').find('.ship-det-table2').toggleClass('dis-none');
				$(this).find(".fa").toggleClass('fa-plus fa-minus');
			});
			$('.ship-det3').off().on("click", function () {
				$(this).closest('.order-search-table-body3').find('.ship-det-table3').toggleClass('dis-none');
				$(this).find(".fa").toggleClass('fa-plus fa-minus');
			});

			$(".kit").off().on("click", function () {
				$(this).find(".fa").toggleClass('fa-plus fa-minus');
				$(this).closest('.order-search-table-body').find(".search-order-table").toggleClass("dis-none");
				$(this).closest('.order-search-table-body').find(".ship-det-table").addClass("dis-none");
				$(this).closest('.order-search-table-body').find(".ship-det .fa").addClass('fa-plus').removeClass('fa-minus');
			});
		};

		orderDetails.populateInitialContext = function () {
			var queryData = orderDetails._queryData;

			if (orderDetails._b2bUnit.isUnitSet) {
				orderDetails.context.unitType = orderDetails._b2bUnit.currentUnit.unitType;
			}

			return orderDetails._api.orders.getOrder(queryData).then(function (res) {
				if (res && res.status == 200) {
					orderDetails.context.order = res.body.orderData;
					orderDetails.context.kits = res.body.productAccessoriesRelation;
				} else {
					throw res;
				}
			});
		};

		orderDetails.handlers = {
			onProductTitleClick: function (entryNumber) {
				orderDetails.itemCollection.findItemByEntryNumber(entryNumber).showProductDetails();
			},
			onAddToCartItem: function (entryNumber) {
				var access = orderDetails._b2bUnit.checkB2BUnit();
				if (!access) {
					orderDetails._modals.warning.show(orderDetails._messages.noB2bUnitSelected);
					return;
				}
				orderDetails.itemCollection.findItemByEntryNumber(entryNumber).addToCart(entryNumber);
			},
			onDataPackItemClick: function (entryNumber, type) {
				orderDetails.itemCollection.findItemByEntryNumber(entryNumber).downloadDataPack(type);
			},
			onGoBack: function () {
				if (orderDetails._breadcrumbs.getPreviousPageTitle() == "ordersOverview") {
					orderDetails._goBackInHistory();
				} else {
					orderDetails._goToPage("ordersOverview");
				}
			}
		};

		orderDetails.init = function () {
			orderDetails.populateInitialContext().then(function () {

				orderDetails._renderPageTemplate();

				if (orderDetails._queryData.scrollToTracking != null) {
					orderDetails._scrollTo(orderDetails.elements.productTable);
				}

				orderDetails.itemCollection.setCollection(orderDetails.context.order.entries);

				orderDetails._bindings();

				orderDetails._events.dispatchEvent("controllerInitialized");
				
				window.scrollTo(0,650);

			}).fail(function (e) {
				console.log(e);
				orderDetails._goToPage("index");
			});
		};


		return orderDetails;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});